import React, { useState, useEffect } from 'react';
import Form from "../../../componets/form/Form";
import useAppContext from "../../../hooks/useAppContext";
import {LoginData} from "../../../types";
import Input from "../../../componets/inputs/Input";
import Alert from "../../../helpers/Alert";
import Storage from '../../../helpers/Storage';
import useForm from "../../../hooks/useForm";
import authApi from "../../../services/authApi";
import Button from "../../../componets/button/Button";
import logo from '../../../assets/img/logo-branco.png';
export default function Login() {
    const [loading, setLoading] = useState(false);
    const appContext = useAppContext();
    const { form, handleChange } = useForm<LoginData>({
        validator: (data) => data.password && data.email
    });
    async function handleSubmit() {
        setLoading(true);
        const { data, isError } = await authApi.login(form);
        if (isError) {
            setLoading(false);
            Alert.error(data.message);
            return;
        }

        Storage.setApiToken(data.token);
        Storage.setUserData({ usuario: data.usuario });

        appContext.setUsuario(data.usuario);
        setLoading(false);
        window.location.href = '/imoveis/lista';
    }
    return(
        <section
            className="h-screen bg-[#003641]"
        >
            <div className="md:container w-full h-full">
                <div className="grid  lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 min-[450px]:grid-cols-1 content-center justify-items-center h-full" >
                    <div className="col-span-1 flex items-center md:mb-[50px] sm:mb-[50px] max-[621px]:mb-[50px]">
                        <div className={'flex 2xl:flex-row xl:flex-row lg:flex-row md:flex-col sm:flex-col max-[621px]:flex-col md:items-center sm:items-center max-[621px]:items-center 2xl:gap-[90px] xl:gap-[90px] lg:gap-[90px]  md:gap-[10px] sm:gap-[10px] max-[621px]:gap-[10px]   gap-[90px]'}>
                            <img src={logo} className={'w-[300px]'}/>
                        </div>

                    </div>
                    <div className="col-span-1 ">
                        <div className="border bg-white  rounded-md   max-[450px]:w-[350px] pb-[60px] w-[469px] ">
                            <div className={" h-full md:px-[50px] xs:px-[20px] mt-[60px]"}>
                                <h1 className=" font-bold  ">
                                    Fazer Login
                                </h1>
                                <div className={'text-base font-semibold  mt-[23px] mb-[23px]'}>
                                    Digite seus dados para acessar
                                </div>
                                <Form className="mt-5 grid gap-[22px]"  onSubmit={() => handleSubmit()}>
                                    <Input
                                        large
                                        placeholder={'E-mail'}
                                        inputType="email"
                                        value={form?.email}
                                        setValue={(v) => handleChange(v, 'email')}
                                        required
                                    />
                                    <Input
                                        large
                                        placeholder={'Senha'}
                                        inputType="password"
                                        value={form?.password}
                                        setValue={(v) => handleChange(v, 'password')}
                                        required
                                    />

                                    <Button loading={loading} type={'submit'} className={'col-span-1 bg-[#003641] hover:bg-[#004856] text-white'}>Entrar</Button>

                                </Form>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
}